import { useState, useEffect } from "react";

const SERVICES_LEFT = [
  {
    label: "Education Loans",
    color: "#0ea5e9",
    image: "/service-education-loan.png",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
        <polyline points="9 22 9 12 15 12 15 22" />
      </svg>
    ),
  },
  {
    label: "Accommodation Guidance",
    color: "#0ea5e9",
    image: "/service-accommodation.png",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 4v16M22 4v16M2 8h20M2 16h20" />
        <rect x="6" y="10" width="4" height="4" rx="1" />
        <rect x="14" y="10" width="4" height="4" rx="1" />
      </svg>
    ),
  },
  {
    label: "Pre-departure Guidance",
    color: "#f59e0b",
    image: "/service-predeparture.png",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2" />
        <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
        <line x1="12" y1="12" x2="12" y2="16" />
        <line x1="10" y1="14" x2="14" y2="14" />
      </svg>
    ),
  },
  {
    label: "Visa Process Guidance",
    color: "#ef4444",
    image: "/service-visa.png",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="16" rx="2" />
        <circle cx="12" cy="10" r="3" />
        <path d="M6 20c0-2.2 2.7-4 6-4s6 1.8 6 4" />
      </svg>
    ),
  },
];

const SERVICES_RIGHT = [
  {
    label: "Admission Guidance",
    color: "#22c55e",
    image: "/service-admission.png",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M6 8l6-5 6 5" />
        <path d="M4 11v9a1 1 0 001 1h4v-5h6v5h4a1 1 0 001-1v-9" />
        <path d="M3 13l9-7 9 7" />
      </svg>
    ),
  },
  {
    label: "Application Processing",
    color: "#f97316",
    image: "/service-application.png",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" />
        <rect x="9" y="3" width="6" height="4" rx="1" />
        <path d="M9 12l2 2 4-4" />
      </svg>
    ),
  },
  {
    label: "Scholarship Guidance",
    color: "#8b5cf6",
    image: "/service-scholarship.png",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z" />
      </svg>
    ),
  },
  {
    label: "Test Preparation",
    color: "#3b82f6",
    image: "/service-test-prep.png",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="15" x2="12.01" y2="15" />
      </svg>
    ),
  },
];

const ALL_PILLS = [...SERVICES_LEFT, ...SERVICES_RIGHT];

function ServicePill({ label, color, icon, isActive, side }) {
  return (
    <div
      className={`service-pill${isActive ? " service-pill--active" : ""}`}
      style={
        isActive
          ? {
              boxShadow: `0 0 0 2.5px ${color}, 0 8px 28px ${color}55`,
              transform: "scale(1.09)",
              background: "#fff",
            }
          : {}
      }
    >
      {isActive && side === "left" && (
        <span className="pill-pointer pill-pointer--right">👉</span>
      )}


      <span className="pill-icon" style={{ color, background: `${color}18` }}>
        {icon}
      </span>
      <span className="pill-label">{label}</span>

      {isActive && side === "right" && (
        <span className="pill-pointer pill-pointer--left">👈</span>
      )}
    </div>
  );
}

export default function HeroSection() {
  const [activeIdx, setActiveIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(
      () => setActiveIdx((i) => (i + 1) % ALL_PILLS.length),
      3500
    );
    return () => clearInterval(id);
  }, []);

  return (
    <section className="hero-section">
      <div className="hero-inner">

        {/* Left pills */}
        <div className="hero-col hero-col-left">
          {SERVICES_LEFT.map((s, i) => (
            <ServicePill key={s.label} {...s} side="left" isActive={activeIdx === i} />
          ))}
        </div>

        {/* Center */}
        <div className="hero-col hero-col-center">
          <div className="hero-globe-wrap">
            {/* Single spinner — globe grid + image rotate together */}
            <div className="globe-spinner">
              <img
                key={activeIdx}
                className="globe-image"
                src={ALL_PILLS[activeIdx].image}
                alt={ALL_PILLS[activeIdx].label}
              />
              <svg className="globe-svg" viewBox="0 0 420 420" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="210" cy="210" r="200" fill="url(#globeGrad)" opacity="0.45" />
                <ellipse cx="210" cy="210" rx="130" ry="200" stroke="#93c5fd" strokeWidth="1.5" fill="none" opacity="0.7" />
                <ellipse cx="210" cy="210" rx="200" ry="130" stroke="#93c5fd" strokeWidth="1.5" fill="none" opacity="0.7" />
                <ellipse cx="210" cy="210" rx="60" ry="200" stroke="#93c5fd" strokeWidth="1" fill="none" opacity="0.5" />
                <line x1="10" y1="210" x2="410" y2="210" stroke="#93c5fd" strokeWidth="1" opacity="0.5" />
                <line x1="210" y1="10" x2="210" y2="410" stroke="#93c5fd" strokeWidth="1" opacity="0.5" />
                <defs>
                  <radialGradient id="globeGrad" cx="40%" cy="40%" r="60%">
                    <stop offset="0%" stopColor="#dbeafe" stopOpacity="0.6" />
                    <stop offset="100%" stopColor="#bfdbfe" stopOpacity="0.2" />
                  </radialGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>

        {/* Right pills */}
        <div className="hero-col hero-col-right">
          {SERVICES_RIGHT.map((s, i) => (
            <ServicePill key={s.label} {...s} side="right" isActive={activeIdx === i + 4} />
          ))}
        </div>

      </div>

      {/* Active label */}
      <div className="hero-active-label">
        <span key={activeIdx} className="hero-active-text" style={{ color: ALL_PILLS[activeIdx].color }}>
          ✦ {ALL_PILLS[activeIdx].label}
        </span>
      </div>

      {/* Headline */}
      <div className="hero-headline">
        <h2>Your Trusted Partner for Global Education</h2>
        <p>Welcome to UniGlobal Overseas — free end-to-end support for your study abroad journey.</p>
        <a href="#apply" className="btn-hero">Apply Now</a>
      </div>
    </section>
  );
}
